import styled from "styled-components";
import { COLORS, FONT_SIZE, FONTS } from "../../../../constants/Styles";
import { QUOTE_TOOL_BACKGROUND_COLOR } from "../QuoteStyles";

export const BreakdownContainer = styled.div<{ depth: number }>`
  background-color: ${({ depth }) =>
    depth % 2 == 1 ? COLORS.background : QUOTE_TOOL_BACKGROUND_COLOR};
  min-width: 20rem;
  max-width: 30rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin: auto;
  padding: ${({ depth }) => depth > 0 && "1rem"};
`;

export const GroupTitle = styled.div`
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size14};
  font-family: ${FONTS.spaceGrotesk};
`;

export const ExpandText = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  font-family: ${FONTS.body};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem;
`;
export const SetQuoteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
